var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustom19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2895.8 2115",
    style: {
      enableBackground: "new 0 0 2895.8 2115"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#007CFF;}\n\t.st2{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st3{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st4{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st5{opacity:0.2;enable-background:new    ;}\n\t.st6{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.2;fill:#FFFFFF;}\n\t.st8{fill:#1A2E35;}\n\t.st9{opacity:0.6;enable-background:new    ;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#CC7A63;}\n\t.st12{fill:#FD897B;}\n\t.st13{fill:none;stroke:#1A2E35;stroke-width:3.3645;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:#B84D3C;}\n\t.st15{fill:none;stroke:#1A2E35;stroke-width:4.8763;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:#FD5652;}\n\t.st17{opacity:0.1;enable-background:new    ;}\n\t.st18{opacity:0.4;enable-background:new    ;}\n\t.st19{fill:none;}\n\t.st20{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st21{opacity:0.3;enable-background:new    ;}\n\t.st22{opacity:0.6;fill:#FFFFFF;}\n\t\n\t\t.st23{opacity:0.2;fill:none;stroke:#000000;stroke-width:3.4439;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st24{opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    className: "st0",
    cx: 1472.6,
    cy: 1962,
    rx: 1335.5,
    ry: 78
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.7,1745.8c-1-7.1-25.2-173.4,23.1-230.8c10.7-12.7,24.2-19.4,40.1-19.7c97.5-2.3,110.8,76,110.9,76.8 l-11.5,1.8c-0.4-2.8-12-69.1-99.2-67c-12.6,0.3-22.9,5.4-31.5,15.6c-45,53.5-20.8,219.9-20.5,221.6L309.7,1745.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.8,1738.2l-11.6-0.4c0-1.5,3.9-153.3-70.9-184.6c-73.3-30.7-106.2,32.4-107.6,35.1l-10.4-5.2 c0.4-0.8,39.1-75.6,122.5-40.6C307.9,1576.9,304,1731.6,303.8,1738.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.1,1750.1c0-2.4-0.7-242.4-47.5-312.6c-44.9-67.4-117.4-35.7-120.4-34.3l-4.8-10.6 c0.8-0.4,84.5-37.3,134.9,38.4c48.7,73.1,49.4,309,49.4,319L304.1,1750.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.8,1501c0,0-42.6,15.7-29.9,52.7c12.7,37,147.2,98,147.2,98s56.4-51.7,4.6-135.7 C457,1432,388,1474.5,386.8,1501z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.5,1424.9c0,0,30.2-3.2,27.8-21.6c-2.4-18.4-117.5-65.8-185.3,10.8c0,0,43.5,74.7,106.3,75.6 C266,1490.7,254.5,1424.9,254.5,1424.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.5,1547.9c0,0,20.9-16.8-1.7-25.1c-22.5-8.2-132.9-5.9-134.1,103.5c0,0,128.6,21.4,144.5-20.3 C248.2,1564.4,223.5,1547.9,223.5,1547.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.8,1501c0,0-42.6,15.7-29.9,52.7c12.7,37,147.2,98,147.2,98s56.4-51.7,4.6-135.7 C457,1432,388,1474.5,386.8,1501z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.5,1424.9c0,0,30.2-3.2,27.8-21.6c-2.4-18.4-117.5-65.8-185.3,10.8c0,0,43.5,74.7,106.3,75.6 C266,1490.7,254.5,1424.9,254.5,1424.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.5,1547.9c0,0,20.9-16.8-1.7-25.1c-22.5-8.2-132.9-5.9-134.1,103.5c0,0,128.6,21.4,144.5-20.3 C248.2,1564.4,223.5,1547.9,223.5,1547.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "409.7,1968.6 210.1,1968.6 188.6,1750.1 431.2,1750.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "409.7,1968.6 210.1,1968.6 188.6,1750.1 431.2,1750.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.9,
    y: 1726,
    className: "st1",
    width: 264,
    height: 48.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.9,
    y: 1726,
    className: "st2",
    width: 264,
    height: 48.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2454.5,892.9h-678.2c-33.6,0-60.8,27.2-60.8,60.8l-82.7,526.7h799.9l82.7-526.7 C2515.3,920.2,2488.1,892.9,2454.5,892.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2454.5,892.9h-678.2c-33.6,0-60.8,27.2-60.8,60.8l-82.7,526.7h799.9l82.7-526.7 C2515.3,920.2,2488.1,892.9,2454.5,892.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2311,1488.2h121.7l82.7-534.5c0-33.6-27.2-60.8-60.8-60.8h0c-33.6,0-60.8,27.2-60.8,60.8L2311,1488.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1607.4,1234.4l-288.4,0c-1,0-2-0.2-3.1-0.2c-41,0-74.2,33.2-74.2,74.2v660.2h77.3h71.2h287v-660.2 C1677.3,1268.5,1646.9,1236,1607.4,1234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1607.4,1234.4l-288.4,0c-1,0-2-0.2-3.1-0.2c-41,0-74.2,33.2-74.2,74.2v660.2h77.3h71.2h287v-660.2 C1677.3,1268.5,1646.9,1236,1607.4,1234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1316,1234.2L1316,1234.2c-41,0-74.2,33.2-74.2,74.2v660.2h148.5v-660.2 C1390.3,1267.4,1357,1234.2,1316,1234.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1438.7,
    y: 1421.1,
    className: "st1",
    width: 567.6,
    height: 547.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1438.7,
    y: 1421.1,
    className: "st4",
    width: 567.6,
    height: 547.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2127.3,1531.3h-647.1c-43.2,0-78.2-35-78.2-78.2v0c0-43.2,35-78.2,78.2-78.2h647.1V1531.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2127.3,1531.3h-647.1c-43.2,0-78.2-35-78.2-78.2v0c0-43.2,35-78.2,78.2-78.2h647.1V1531.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2372,1234.4l-288.4,0c-1,0-2-0.2-3.1-0.2c-41,0-74.2,33.2-74.2,74.2v660.2h77.3h71.2h287v-660.2 C2441.8,1268.5,2411.5,1236,2372,1234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2372,1234.4l-288.4,0c-1,0-2-0.2-3.1-0.2c-41,0-74.2,33.2-74.2,74.2v660.2h77.3h71.2h287v-660.2 C2441.8,1268.5,2411.5,1236,2372,1234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2080.6,1234.2L2080.6,1234.2c-41,0-74.2,33.2-74.2,74.2v660.2h148.5v-660.2 C2154.8,1267.4,2121.6,1234.2,2080.6,1234.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2259.7,
    y: 1259.4,
    className: "st1",
    width: 511.8,
    height: 709.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2614.4,
    y: 1259.4,
    className: "st5",
    width: 157,
    height: 709.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2285.1,
    y: 1284.7,
    className: "st7",
    width: 294.3,
    height: 110.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2285.1,
    y: 1422.5,
    className: "st7",
    width: 294.3,
    height: 110.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2285.1,
    y: 1560.2,
    className: "st7",
    width: 294.3,
    height: 294.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 2424.8,
    cy: 1306.1,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 2424.8,
    cy: 1438.9,
    r: 11.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2311,1707.4c0,6.4-5.2,11.6-11.6,11.6c-6.4,0-11.6-5.2-11.6-11.6c0-6.4,5.2-11.6,11.6-11.6 C2305.8,1695.8,2311,1701,2311,1707.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2555.5,
    y: 818.1,
    className: "st8",
    width: 33.1,
    height: 441.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2395.4,969.7 2748.7,969.7 2720.1,719.7 2424,719.7  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2395.4,969.7 2748.7,969.7 2720.1,719.7 2424,719.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2555.5,1070.4 2555.5,1259.4 2588.6,1259.4 2588.6,1049.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2630,1240 2514.1,1240 2493.5,1259.4 2650.6,1259.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2630,1240 2514.1,1240 2493.5,1259.4 2650.6,1259.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M707.9,212.1c-8.6-5.1-18.9-7.7-30.2-5.6c-29.5,5.6-36.5,34.7-32.6,55.9c2.7,14.4,14.8,32.9,33.4,37.6 c23.2,5.8,43.7-15.7,49.7-31.8C735.7,248.2,729,224.7,707.9,212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1227.7,528.8l116.5-32.7c0,0,0.1-6.7,18.1-19.7c18-13,66.6-23,66.6-23s22.3,64.5,15.1,66.3 c-7.2,1.8-72.6,23.6-76.2,16.4L1244,571.2L1227.7,528.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M872.8,394.2c68,22,173.9,141.9,194.5,149.1c20.7,7.3,218.5-35.5,218.5-35.5l27.7,50.9 c0,0-181.5,65.7-246.3,60.6c-64.7-5.1-149-101-209.5-114.8L872.8,394.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1313.6,558.7c0,0-181.6,65.7-246.2,60.6c-41.8-3.3-91.7-44.4-138.1-76.9c-25.6-17.8-50-33-71.4-38l7.9-57.7 l7.2-52.6c68,22,173.8,141.8,194.5,149.1c20.6,7.2,218.5-35.5,218.5-35.5L1313.6,558.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M929.3,542.5c-25.6-17.8-50-33-71.4-38l7.9-57.7C885.2,465.7,915.2,500.1,929.3,542.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "973,1873.2 927.1,1881.3 908.3,1818.8 891.1,1761.3 944,1742.9 959.4,1811.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M916.7,1880.1c-0.8-5.1,62.1-12.1,62.1-12.1s45.1,32.1,83.8,34.3c38.7,2.2,21.9,28.1-19.6,35.5 c-41.5,7.3-73.2,12.9-102.7,18.1C910.8,1961.1,924.8,1932.8,916.7,1880.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1009.7,1878.5c-8.6,0-19.5-2.9-22.5-3.7c-0.2-0.1-0.4-0.1-0.5-0.3l0,0l0,0c-0.2-0.1-0.3-0.3-0.4-0.5l0,0 c0,0,0,0,0,0c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0,0,0,0h0c-0.1-0.2-0.1-0.5,0-0.7c0.1-0.7,2.8-16.1,10.6-21.1c2.5-1.6,5.2-2,8.1-1.2 c3.1,0.8,4.8,2.4,5,4.5c0.4,3.3-3.5,7.4-8,11c5.2-1.4,10.6-2.2,14.2-0.9c1.9,0.7,3.3,1.9,4.1,3.6c1.6,3.5,0.7,5.7-0.3,6.9 C1017.7,1877.8,1014,1878.5,1009.7,1878.5z M992.7,1872.8c9.8,2.3,21.8,3.7,24.3,0.7c0.2-0.3,0.9-1-0.2-3.4 c-0.4-0.9-1.1-1.5-2.2-1.9C1009.7,1866.5,999.4,1870,992.7,1872.8z M1001.8,1853.6c-1.2,0-2.4,0.4-3.5,1.1 c-4.3,2.7-7,10.2-8.3,15.2c8.6-5.1,16.6-11.5,16.3-14.4c-0.1-0.9-1.7-1.4-2.6-1.7C1003.1,1853.7,1002.5,1853.6,1001.8,1853.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "959.6,1813.3 908.5,1820 891.2,1762 944.1,1743.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "666.7,1892.9 620.1,1892.9 612.4,1828 605.5,1768.5 660.8,1759.5 663.9,1830.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M610.1,1889.9c0.1-5.1,63.2-1.1,63.2-1.1s38.8,39.5,76.5,48.4c37.7,8.9,16.6,31.5-25.5,31.5s-74.3,0-104.3,0 C590.1,1968.6,608.9,1943.1,610.1,1889.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.5,1904.9c-8.8,0-22.8-6.4-26.2-8c-0.2-0.1-0.4-0.2-0.6-0.4l0,0h0c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.2-0.4-0.2-0.8-0.1-1.3c0.2-0.6,5.5-15.4,14.1-18.9c2.7-1.1,5.5-1,8.2,0.2c2.9,1.4,4.3,3.1,4.1,5.3c-0.2,3.3-4.7,6.6-9.8,9.4 c5.3-0.5,10.8-0.4,14.2,1.5c1.8,1,2.9,2.5,3.4,4.3c1,3.7-0.3,5.7-1.5,6.7C710.8,1904.5,708.8,1904.9,706.5,1904.9z M686.1,1895.9 c9.3,3.9,20.9,7.4,23.8,5c0.3-0.2,1-0.9,0.4-3.3c-0.2-0.9-0.8-1.6-1.8-2.2C704,1892.7,693.2,1894.3,686.1,1895.9z M697.4,1878.5 c-0.8,0-1.7,0.2-2.6,0.5c-4.7,1.9-8.6,8.8-10.8,13.6c9.4-3.6,18.4-8.5,18.5-11.3c0.1-0.9-1.4-1.7-2.2-2.1 C699.4,1878.7,698.4,1878.5,697.4,1878.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "663.9,1831.5 612.4,1829.3 605.5,1769.1 660.8,1759.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M963.9,1776.9l-75.4,13.3c-76.1-189.6-130.2-347.9-168.5-479.3c-20.6-70.9-36.6-133.9-49-189.8l3.4,206.4 v468.9h-76.6C411.6,907.9,543.6,704.9,543.6,704.9l222.9-38.1c8.5,33.3,14.9,87.2,18.7,124.7l10.1,73.7l87.1,449.9L963.9,1776.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M963.9,1776.9l-75.4,13.3c-76.1-189.6-130.2-347.9-168.5-479.3c-20.6-70.9-36.6-133.9-49-189.8l3.4,206.4 v468.9h-76.6C411.6,907.9,543.6,704.9,543.6,704.9l222.9-38.1c8.5,33.3,14.9,87.2,18.7,124.7l10.1,73.7l87.1,449.9L963.9,1776.9z "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "876.7,1780.9 970.2,1749.8 969,1789.6 891.6,1814.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "587.9,1785.2 685.4,1770.9 677.3,1809.9 596.8,1820.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M720,1310.9c-20.6-70.9-36.6-133.9-49-189.8c0,0,1.2-108.7,14.4-198C685.5,923.1,718.1,1178.5,720,1310.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.2,837.7L708,869.8L690.3,812l-19.3,53.4l-172.8-40.2c14.8-106.1,74-190.7,83.3-222.8 c12.8-44.4,22.8-129.2,14.1-184.1c0-0.1,0-0.3-0.1-0.4c-3.6-23.4,13.3-45.1,36.9-47c16.7-1.3,33.5-1.9,50.3-2 c33.3-0.4,66.6,1.6,99.6,5.9c42.5,6.7,90.4,19.6,90.4,19.6s6.6,2.8,3.6,48.5c-2.8,39.9-10.4,163.8-92,268.7L803.2,837.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M803.2,837.7L708,869.8L690.3,812l-19.3,53.4l-172.8-40.2c14.8-106.1,74-190.7,83.3-222.8 c12.8-44.4,22.8-129.2,14.1-184.1c0-0.1,0-0.3-0.1-0.4c-3.6-23.4,13.3-45.1,36.9-47c16.7-1.3,33.5-1.9,50.3-2 c33.3-0.4,66.6,1.6,99.6,5.9c42.5,6.7,90.4,19.6,90.4,19.6s6.6,2.8,3.6,48.5c-2.8,39.9-10.4,163.8-92,268.7L803.2,837.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.3,453.4c0,0,38.1,33,49.1,117.8l42.9-118.5l29.5,9c0,0-22.7-107.5-96.7-109.5 c-74-2-68.2,109.5-68.2,109.5L706.3,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M706.3,453.4c0,0,38.1,33,49.1,117.8l42.9-118.5l29.5,9c0,0-22.7-107.5-96.7-109.5 c-74-2-68.2,109.5-68.2,109.5L706.3,453.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M813.2,332.5c0,0-27,17.5-31.7,29c-0.3,0.6-0.5,1.4-0.7,2.3c-1.7,6.6-2.7,19.9-2.7,19.9 c21,44.4-18.9,120.9-18.9,120.9c-23.6-69.9-67.7-126.1-67.7-126.1c43.3-17,51.6-100,51.6-100l21,16.2L813.2,332.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M813.2,332.5c0,0-27,17.5-31.7,29c-0.3,0.6-0.5,1.4-0.7,2.3c-39.3-30.1-34.3-75.1-34.3-75.1l17.5,6 L813.2,332.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M843.2,137.8c0,0,54.6-15.3,81.1,28.8c26.4,44.1,5.3,77.5-13.1,93.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M865,135.4c0,0,44.5,1.4,56.8,39c12.3,37.6,3.2,79.8-62.9,125.3c-32.3,22.3-112.5-21.2-112.5-21.2l-6.4,19.4 c-11.8-8.5-21.6-18.2-29-26.9c-26-30.5-19.3-131.3,52.8-151.1C839,99.3,865,135.4,865,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M822.5,147.9c56.6,7.7,70.6,40.5,66.8,99.3c-4.7,73.5-27.9,123.1-96.5,97.9 C699.6,310.9,728.6,135.1,822.5,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M853.2,239.1c0,0,5.8,15.8,13.3,25.7c0,0-5.9,7-15.8,4.4L853.2,239.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M819.2,229.8c-0.5,4.7-3.5,8.2-6.6,7.8c-3.1-0.3-5.2-4.4-4.7-9.1c0.5-4.7,3.5-8.2,6.6-7.8 C817.7,221,819.8,225.1,819.2,229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M813.2,220.8l10.6-2.8C823.8,217.9,817.8,225.9,813.2,220.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M877.3,235.3c-0.5,4.7-3.5,8.2-6.6,7.8c-3.1-0.3-5.2-4.4-4.7-9.1c0.5-4.7,3.5-8.2,6.6-7.8 C875.7,226.6,877.8,230.6,877.3,235.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M871.3,226.3l10.6-2.8C881.9,223.5,875.9,231.4,871.3,226.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M824,190.6c0,0-15.6-4.2-25.7,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M865.4,193.8c0,0,10.5-2.3,21.9,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M747.7,234.8c0,0,32.8-42.9,33.7-79.3c0,0,118.3-30.5,108.4,84c0,0,24.7-99.5-72.2-115 c-96.8-15.5-119.3,118-74.8,167.2C742.7,291.7,727.4,261.7,747.7,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M755.3,248c0.9-9.2-6.4-25.9-23.6-26.3c-17.8-0.5-31,34.4,11.4,49C749.2,272.8,753.5,267.1,755.3,248z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M847.7,286.1c-3,7.2-5.7,20.6-5.7,20.6c-1.3,0-2.5-0.1-3.8-0.1c-17.1-0.8-24.7-6.8-28.1-13.2 c-1.8-3.5-2.3-7.2-2.2-10.2c0-3.5,0.8-5.9,0.8-5.9c8.8,5.8,24.7,7.8,33.2,8.5C845.4,286,847.7,286.1,847.7,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M841.9,285.7l-1.8,6c-16.1-0.8-27.3-3.5-32.1-8.6c0-3.5,0.8-5.9,0.8-5.9 C817.5,283.1,833.3,285,841.9,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M838.2,306.6c-17.1-0.8-24.7-6.8-28.1-13.2c5.8,0.5,12.8,1.7,18.8,4.6 C833.6,300.2,836.4,303.4,838.2,306.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M697,201.6l4.1-88l-15.5-24.3c0,0,60.3-24.5,125.5-9.1l53.8,55.3C865,135.4,761.1,109.5,697,201.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M864.9,135.4c0,0-58.7-14.6-115,17.3c-18.7,10.5-37,26-52.9,48.9l4.1-88l-15.5-24.3c0,0,60.3-24.5,125.5-9.1 L864.9,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M749.9,152.7c-18.7,10.5-37,26-52.9,48.9l4.1-88l-15.5-24.3L749.9,152.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M962.6,770l76.4,17.5c0,0,27.2,1.1,55.9,9.5c28.6,8.4,59.6,20.6,55,28.1c-4.6,7.5-54.2,47.3-70,44.7 c-15.8-2.6-60.4-27.7-55.4-39.9l-74-17.9L962.6,770z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.4,375.5c27.1-8,79.8,248,118.7,291.3c38.9,43.3,273,107.1,273,107.1l-11.9,51.2 c0,0-287.1-34.9-325.2-89.3c-38.1-54.4-91.3-201-98.1-274.2S600.5,380.2,616.4,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M616.4,375.5c27.1-8,79.8,248,118.7,291.3c38.9,43.3,273,107.1,273,107.1l-11.9,51.2 c0,0-287.1-34.9-325.2-89.3c-38.1-54.4-91.3-201-98.1-274.2S600.5,380.2,616.4,375.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "862.1,591.7 786.4,586.6 791.8,544.4 867.5,549.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "858,588.4 792.9,584 797.5,547.7 862.7,552.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "831.9,532.9 824.6,553.3 836.8,553.3 836.8,532.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__69_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1060.9,829.9l-70.5,13.3c0,0-73.7-16.1-86.6-13.3c-12.8,2.8-46,67.9-46,67.9s113.3,24.7,127.8,19.9 c14.4-4.8,26.4-23.6,26.4-23.6l55.3-10.2L1060.9,829.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1204.9,496c-33.4,50.1,15.1,253.2,18.1,266.1c3,12.9-198.6,67.5-198.6,67.5l29.1,88.9 c0,0,251.3-29,279.2-59c27.8-30-3.5-276.3-3.5-276.3L1204.9,496L1204.9,496L1204.9,496z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1332.7,859.5c-23.8,25.6-210,50.4-264.4,57.2c-9.4,1.2-14.9,1.8-14.9,1.8l-29.1-88.9c0,0,5-1.3,13.2-3.7 c44.8-12.4,188-52.9,185.4-63.8c-3-12.9-51.5-216-18.1-266.1l21.6,9.1l71.4,54.3l31.3,23.8c0,0,12.2,95.7,14.6,175v0.1 C1345.2,806.2,1343.2,848.2,1332.7,859.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1068.3,916.6c-9.4,1.2-14.9,1.8-14.9,1.8l-29.1-88.9c0,0,5-1.3,13.2-3.7L1068.3,916.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1343.8,758.2c-41.2-66.2-45.4-138.7-45.9-198.9l31.3,23.8C1329.2,583.2,1341.4,678.9,1343.8,758.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1120.9,906.9H871.6c-29.9,0-54.9,23.4-56.8,53.3l-11.6,187.8h386.1l-11.6-187.8 C1175.8,930.3,1150.9,906.9,1120.9,906.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M752.6,1968.5l48.5-786.1h390.3l48.5,786.1h34.5L1212.1,958c-3.1-48-43.1-85.5-91.2-85.5H871.6 c-48.1,0-88.1,37.6-91.2,85.6l-62.4,1010.4H752.6z M814.8,960.2c1.9-29.9,26.9-53.3,56.8-53.3h249.3c29.9,0,54.9,23.4,56.8,53.2 l11.6,187.8H803.2L814.8,960.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1473.3,1916.3 1419.4,1932.1 1387.6,1815.4 1441.5,1799.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1413.5,1907h65.7c2.2,0,4.1,1.6,4.6,3.7l10.7,48.2c0.9,4.3-1.8,8.6-6.2,9.5c-0.6,0.1-1.2,0.2-1.8,0.2 c-21.3-0.3-36.8-1.7-63.5-1.7c-16.4,0-66.1,1.7-88.8,1.7c-22.7,0-25.7-22.4-16.4-24.5c41.7-9.1,73.1-21.7,86.4-33.7 C1406.9,1908.2,1410.2,1907,1413.5,1907z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1441.5,1799.7 1387.6,1815.4 1404.1,1875.6 1458,1859.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1648.5,800.2c0,0,23.1,104.3,18.2,225.6c-4.8,121.2-279,271.8-284.2,314.2c-5.2,42.4,84.4,485.3,84.4,485.3 l-94.6,33.6c0,0-186.9-401-189.1-499.1c-2.2-98.2,204.4-334,260.8-399c21.9-25.3,0.4-127,0.4-127L1648.5,800.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1666.7,1025.7c-1.7,43.9-38.7,91.5-85.5,136.6c-74.5,71.8-173.8,136.8-194.8,168.6c-2.3,3.4-3.6,6.4-3.9,9 c-5.2,42.4,84.4,485.3,84.4,485.3l-94.6,33.5c0,0-186.9-400.9-189.1-499.1c-2.2-98.2,204.4-334,260.8-399 c21.9-25.3,0.3-127,0.3-127l204.1-33.5C1648.4,800.2,1671.5,904.5,1666.7,1025.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1366.4,1875.5 1481.6,1836.4 1472.1,1804.3 1351.8,1842.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1366.4,1875.5 1481.6,1836.4 1472.1,1804.3 1351.8,1842.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1581.2,1162.3c-74.5,71.8-173.8,136.8-194.8,168.6c4-142.6,176.2-294.5,176.2-294.5L1581.2,1162.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1734.1,1916.3 1680.2,1932.1 1648.5,1815.4 1702.3,1799.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1674.4,1907h65.7c2.2,0,4.1,1.6,4.6,3.7l10.7,48.2c0.9,4.3-1.8,8.6-6.2,9.5c-0.6,0.1-1.2,0.2-1.8,0.2 c-21.3-0.3-36.8-1.7-63.5-1.7c-16.4,0-66.1,1.7-88.8,1.7s-25.7-22.4-16.4-24.5c41.7-9.1,73.1-21.7,86.4-33.7 C1667.8,1908.2,1671,1907,1674.4,1907z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1702.3,1799.7 1648.5,1815.4 1664.9,1875.6 1718.8,1859.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1755.6,775.7c0,0,48.3,100,43.4,221.2s-150.5,300.7-155.7,343.1c-5.2,42.4,84.4,485.3,84.4,485.3l-94.6,33.6 c0,0-186.9-401-189.1-499.1c-2.2-98.2,118.6-323.2,118.6-323.2l-25.2-223.2L1755.6,775.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1755.6,775.7c0,0,48.3,100,43.4,221.2s-150.5,300.7-155.7,343.1c-5.2,42.4,84.4,485.3,84.4,485.3 l-94.6,33.6c0,0-186.9-401-189.1-499.1c-2.2-98.2,118.6-323.2,118.6-323.2l-25.2-223.2L1755.6,775.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1627.2,1875.5 1742.4,1836.4 1732.9,1804.3 1612.7,1842.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1627.2,1875.5 1742.4,1836.4 1732.9,1804.3 1612.7,1842.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1799.3,918.3c0,0-328.7,49.6-361.3,23.2c-48.1-38.9-101.5-363.8-233.1-445.5c0,0,15.3-27,48.9-58.7 c31.3-29.5,78.5-63,144-82.4c36.3-10.7,78.2-17.1,126.1-15.9C1523.9,339,1781.9,522.1,1799.3,918.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1799.3,918.3c0,0-328.7,49.6-361.3,23.2c-3-2.4-6.1-6-9.1-10.5c-46-68-100.6-358.4-224-435 c0,0,15.3-27.1,48.9-58.7c1.8-1.7,3.6-3.4,5.5-5.1c31.2-28.2,76.7-59,138.4-77.4c2.7-0.8,5.4-1.6,8.2-2.3 c34.4-9.4,73.6-14.7,117.9-13.6c0,0,57.5,40.8,120.1,125.6c31.9,43.3,65.2,98,92.8,164.6c29.8,72,53,158,60.7,258.4 C1798.2,897.7,1798.9,907.9,1799.3,918.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1406,352.6c-6.3,31.4-21.2,96.4-46.8,155.3c0,0-67.4-24.9-99.8-75.7c31.2-28.2,76.7-59,138.4-77.4 C1400.5,354,1403.2,353.3,1406,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1799.3,918.3c0,0-328.7,49.6-361.3,23.2c-3-2.4-6.1-6-9.1-10.5c66.8,2.2,205.7-0.2,368.5-43.4 C1798.2,897.7,1798.9,907.9,1799.3,918.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1736.7,629.2c-115.2-30.4-175.2-160-175.2-160l82.4-4.6C1675.8,507.8,1709.1,562.6,1736.7,629.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1389.9,359.7c-20,72.9-49,85.4-71.7,81.1c-20-3.7-35.2-20.4-35.2-20.4s3.6-5.8,3.2-14.2 c-0.3-7.6-3.7-17.4-15.8-27c-4.3-3.4-9.1-6.3-13.8-9.2l1.4-18.7l7-88.9c10.1,14.9,24.8,36.1,42.1,55c5.2,5.6,10.6,11.2,16.2,16.2 C1344.1,352.5,1367.4,365.3,1389.9,359.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1318.2,440.8c-20-3.7-35.2-20.4-35.2-20.4s3.6-5.8,3.2-14.2c-0.3-7.6-3.7-17.4-15.8-27 c-4.3-3.4-9.1-6.3-13.8-9.2l1.4-18.7l65.2-17.8C1323.2,333.6,1339.6,398.6,1318.2,440.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1155.2,258.6c0,0-19.5-2.1-22.7,23.3c-3.2,25.3,5.4,25.8,5.4,25.8s-6.6,21.3,1.7,27.2 c8.3,6,15.6,31.3,15.6,31.3l19.3-35.4L1155.2,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1155.2,258.6c0,0-19.5-2.1-22.7,23.3c-3.2,25.3,5.4,25.8,5.4,25.8s-6.6,21.3,1.7,27.2 c8.3,6,15.6,31.3,15.6,31.3l19.3-35.4L1155.2,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1305.8,388.8c-1.3,2.7-2.9,5.5-4.6,8.3c-19.1,31.2-52.6,40.9-82.6,33.3c-19.3-4.9-37.2-17.1-48.9-35.4 c-1.6-2.4-3-4.9-4.4-7.5c-2.6-5.2-5.1-11-7.4-17c-18.5-49.4-37.6-116.8,22.1-152.8c37.6-22.6,100.7-25.5,123.3,12.3 c28.2,47.2,12,92.6,12,92.6C1318.6,342,1322,356.1,1305.8,388.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1330.5,276.3c0,0,10-0.5,5.9-13.9c-4.1-13.4-21.2-22-21.2-22s13.4-9.1-4.3-17.7c-8.6-4.2-19.4-4.8-29.4-1.8 c-6-5-58.6-47.2-94.4-22.1c-0.8,0.5-1,1.6-0.4,2.4c0.5,0.8,1.6,1,2.4,0.4c31.2-21.9,78.2,12.5,88.6,20.6 c-0.9,0.4-1.8,0.8-2.7,1.2c-10.7-4.8-89.8-38.8-116.5,1.1c-0.5,0.8-0.3,1.9,0.5,2.4c0.8,0.5,1.9,0.3,2.4-0.5 c23.3-35,93.5-7.8,109.8-0.9c-1.8,1.1-3.4,2.3-5,3.7c-16.4-4.5-68.3-16.7-99.4,0.2c-11,6-18.3,15.2-21.6,27.2 c-0.2,0.9,0.3,1.9,1.2,2.1c0.2,0,0.3,0.1,0.5,0.1c0.8,0,1.5-0.5,1.7-1.3c3-11.1,9.7-19.5,19.9-25.1c28.5-15.5,77-5.1,94.9-0.4 c-2.8,3.1-5.2,6.8-7,11c-9.5,22.7,5.8,31.3,15.8,42.8c9.8,11.3,5.4,30.3,5.2,30.9c-5.7,15.9-21,28.9-21,28.9s-7.3-4.1-19.9,0 c-12.6,4.1-19.5,19.5-19.5,19.5c-30.3-3.2-35.1,21.5-35.1,21.5c-20-13-30.7-37.4-30.7-37.4c-3,27.2,7.1,56.3,16.6,68.1 c9.5,11.8,14.5,0,14.5,0s2.3,23.2,15.2,31.8c12.9,8.6,17.5-1.8,17.5-1.8s6.8,14.5,31.3,20.9c24.5,6.4,32.2-29.1,32.2-29.1 c26.8,20.4,24.5-28.2,24.5-28.2s13.2,3.6,11.9-20.2c-1-18.6-17.5-54.5-24.8-69.6c10.9-1.7,27.7,23.2,27.7,23.2 C1365,348.3,1330.5,276.3,1330.5,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1330.5,276.3c0,0,10-0.5,5.9-13.9c-4.1-13.4-21.2-22-21.2-22s13.4-9.1-4.3-17.7 c-8.6-4.2-19.4-4.8-29.4-1.8c-6-5-58.6-47.2-94.4-22.1c-0.8,0.5-1,1.6-0.4,2.4c0.5,0.8,1.6,1,2.4,0.4 c31.2-21.9,78.2,12.5,88.6,20.6c-0.9,0.4-1.8,0.8-2.7,1.2c-10.7-4.8-89.8-38.8-116.5,1.1c-0.5,0.8-0.3,1.9,0.5,2.4 c0.8,0.5,1.9,0.3,2.4-0.5c23.3-35,93.5-7.8,109.8-0.9c-1.8,1.1-3.4,2.3-5,3.7c-16.4-4.5-68.3-16.7-99.4,0.2 c-11,6-18.3,15.2-21.6,27.2c-0.2,0.9,0.3,1.9,1.2,2.1c0.2,0,0.3,0.1,0.5,0.1c0.8,0,1.5-0.5,1.7-1.3c3-11.1,9.7-19.5,19.9-25.1 c28.5-15.5,77-5.1,94.9-0.4c-2.8,3.1-5.2,6.8-7,11c-9.5,22.7,5.8,31.3,15.8,42.8c9.8,11.3,5.4,30.3,5.2,30.9 c-5.7,15.9-21,28.9-21,28.9s-7.3-4.1-19.9,0c-12.6,4.1-19.5,19.5-19.5,19.5c-30.3-3.2-35.1,21.5-35.1,21.5 c-20-13-30.7-37.4-30.7-37.4c-3,27.2,7.1,56.3,16.6,68.1c9.5,11.8,14.5,0,14.5,0s2.3,23.2,15.2,31.8c12.9,8.6,17.5-1.8,17.5-1.8 s6.8,14.5,31.3,20.9c24.5,6.4,32.2-29.1,32.2-29.1c26.8,20.4,24.5-28.2,24.5-28.2s13.2,3.6,11.9-20.2 c-1-18.6-17.5-54.5-24.8-69.6c10.9-1.7,27.7,23.2,27.7,23.2C1365,348.3,1330.5,276.3,1330.5,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1222.6,306.4c1.4,4.5-0.5,8.9-3.6,9.6c-3.1,0.7-6.3-2.5-7.4-7.1c-1.1-4.6,0.6-8.9,3.6-9.6 C1218.1,298.6,1221.4,301.8,1222.6,306.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1170.3,318.5c1.4,4.5-0.6,8.9-3.6,9.6c-3,0.7-6.3-2.5-7.4-7.1c-1.1-4.6,0.6-8.9,3.6-9.6 C1165.9,310.7,1169.3,314.1,1170.3,318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1187.4,316.9c-2.2,15.4-6.6,30.4-13,44.6c7.5,3.1,16,2.8,23.2-1L1187.4,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1234.9,285.8c-1,0.4-2.1,0.2-2.9-0.5c-5.3-4.7-12.5-6.6-19.5-5.1c-1.5,0.5-3-0.4-3.5-1.8 c-0.4-1.5,0.4-3,1.8-3.5c0,0,0,0,0,0c8.7-2.1,17.9,0.2,24.6,6.1c1.2,0.9,1.4,2.7,0.5,3.9c0,0,0,0,0,0.1 C1235.6,285.3,1235.3,285.5,1234.9,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1143.7,305.6c-0.5,0.3-1,0.5-1.6,0.5c-1.5-0.3-2.5-1.8-2.1-3.3c0,0,0,0,0-0.1c1.8-8.8,7.8-16.2,16-19.8 c1.4-0.5,3,0.2,3.6,1.6c0,0,0,0,0,0c0.5,1.4-0.2,3-1.7,3.6l0,0c-6.4,3-11,8.9-12.4,15.9C1145.1,304.8,1144.5,305.4,1143.7,305.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1234.9,285.8c-1,0.4-2.1,0.2-2.9-0.5c-5.3-4.7-12.5-6.6-19.5-5.1c-1.5,0.5-3-0.4-3.5-1.8 c-0.4-1.5,0.4-3,1.8-3.5c0,0,0,0,0,0c8.7-2.1,17.9,0.2,24.6,6.1c1.2,0.9,1.4,2.7,0.5,3.9c0,0,0,0,0,0.1 C1235.6,285.3,1235.3,285.5,1234.9,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1143.7,305.6c-0.5,0.3-1,0.5-1.6,0.5c-1.5-0.3-2.5-1.8-2.1-3.3c0,0,0,0,0-0.1c1.8-8.8,7.8-16.2,16-19.8 c1.4-0.5,3,0.2,3.6,1.6c0,0,0,0,0,0c0.5,1.4-0.2,3-1.7,3.6l0,0c-6.4,3-11,8.9-12.4,15.9C1145.1,304.8,1144.5,305.4,1143.7,305.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1187.9,394.8c0,0,5,5,11.8-2.7c0,0,9.5,15,19.5-18.2c0,0,26.7,5.3,34.1,0c5-3.6,0-10.3,0-10.3 s10.9-1.1,13.6-9.2c0,0,8.6,32.4-41.3,26.3C1225.6,380.8,1209.5,415.7,1187.9,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1340.6,311.5c-3.3,14.3-12.2,26.7-24.7,34.5c-16.6,10.2-30.2-3.4-30.1-21.8c0.2-16.4,8.9-41.9,27.8-44.4 C1332.5,277.2,1344.5,293.9,1340.6,311.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1211.3,314.4c0,0,2.7,13.2,18.5,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1172.7,324.3c0,0-0.3,15.7-11.2,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1153.1,274.2c0,0,24.7-14.7,51.8-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1153.1,265.9c0,0,20.6-21.3,51.8-12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1159.7,251.4c0,0,17.7-15.9,47.2-7.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1820.3,724l-34.7,38.1c0,0-24.3,14.7-25.8,23.1c-1.5,8.4,30.3,117.5,30.3,117.5s43.2-33.2,41.9-43.2 c-1.4-10-21.8-59.3-21.8-59.3l38-35.3L1820.3,724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1523.9,339c0,0,302.5,20.7,414.2,149.8c111.7,129.1-106.3,311.4-106.3,311.4l-39.3-66.9 c0,0,88.4-89.4,55.7-150.1c-32.7-60.7-199.8-55.4-199.8-55.4S1485.7,460.6,1523.9,339z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1848,785.6c-9.9,9.4-16.2,14.6-16.2,14.6l-39.3-66.9c0,0,3.4-3.4,8.5-9.3c21.3-24.4,73.6-91.8,47.2-140.8 c-32.7-60.8-199.8-55.4-199.8-55.4s-162.7-67.1-124.5-188.8c0,0,302.5,20.7,414.2,149.7C2030.9,595.9,1896.3,739.8,1848,785.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1848,785.6c-9.9,9.4-16.2,14.6-16.2,14.6l-39.3-66.9c0,0,3.4-3.4,8.5-9.3L1848,785.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1198,1040.3H801.7c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2H1198c9.5,0,17.2,7.7,17.2,17.2 C1215.3,1032.5,1207.6,1040.3,1198,1040.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1198,1040.3H801.7c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2H1198c9.5,0,17.2,7.7,17.2,17.2 C1215.3,1032.5,1207.6,1040.3,1198,1040.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1163.6,1563.4H767.2c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2h396.4c9.5,0,17.2,7.7,17.2,17.2 C1180.8,1555.7,1173.1,1563.4,1163.6,1563.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1163.6,1563.4H767.2c-9.5,0-17.2-7.7-17.2-17.2c0-9.5,7.7-17.2,17.2-17.2h396.4 c9.5,0,17.2,7.7,17.2,17.2C1180.8,1555.7,1173.1,1563.4,1163.6,1563.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1527.3,906.9H1278c-29.9,0-54.9,23.4-56.8,53.3l-11.6,187.8h386.1l-11.6-187.8 C1582.2,930.3,1557.2,906.9,1527.3,906.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1158.9,1968.5l48.5-786.1h390.3l48.5,786.1h34.5L1618.5,958c-3.1-48-43.1-85.5-91.2-85.5H1278 c-48.1,0-88.1,37.6-91.2,85.6l-62.4,1010.4H1158.9z M1221.2,960.2c1.9-29.9,26.9-53.3,56.8-53.3h249.3 c29.9,0,54.9,23.4,56.8,53.2l11.6,187.8h-386.1L1221.2,960.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1158.9,1968.5l48.5-786.1h390.3l48.5,786.1h34.5L1618.5,958c-3.1-48-43.1-85.5-91.2-85.5H1278 c-48.1,0-88.1,37.6-91.2,85.6l-62.4,1010.4H1158.9z M1221.2,960.2c1.9-29.9,26.9-53.3,56.8-53.3h249.3 c29.9,0,54.9,23.4,56.8,53.2l11.6,187.8h-386.1L1221.2,960.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom19);
export default __webpack_public_path__ + "static/media/custom-19.de27af72b70aef85e0c623ec88c003de.svg";
export { ForwardRef as ReactComponent };